export const TRIAL_WORDMARK = '/static/images/trial/wordmark.png';

const TRIAL_DEMO_EMBED = '?b=0&title=0&loop=0&t=0&muted=0&wt=0';
export const TRIAL_DEMO_VIDEO_EN = `https://www.tella.tv/video/cmc0r915p000b0bjr6kvoesjs/embed${TRIAL_DEMO_EMBED}`;
export const TRIAL_DEMO_VIDEO_NL = `https://www.tella.tv/video/cmc0r5lyd000d0bky3ijjfidd/embed${TRIAL_DEMO_EMBED}`;

export function trialDemoVideoUrl(languageLocale?: string): string {
  return languageLocale === 'nl' ? TRIAL_DEMO_VIDEO_NL : TRIAL_DEMO_VIDEO_EN;
}

export const TRIAL_MOSAIC_STORE = '/static/images/trial/restaurant-setting-tables.jpg';
export const TRIAL_MOSAIC_CREW = '/static/images/trial/team-restaurant.jpg';

export const TRIAL_FALLBACK_IMAGES = [
  '/static/images/trial/photo-1.jpg',
  '/static/images/trial/photo-2.jpg',
  '/static/images/trial/photo-3.jpg',
  '/static/images/trial/photo-4.jpg',
  '/static/images/trial/photo-5.jpg',
  '/static/images/trial/photo-6.jpg',
  '/static/images/trial/photo-7.jpg',
  '/static/images/trial/photo-8.jpg',
];

type TrialPreviewImages = {
  screenshot_url?: string | null;
  images?: Array<string | null | undefined> | null;
} | null | undefined;

export function trialBackdropImageUrls(preview: TrialPreviewImages): string[] {
  const fromResearch = Array.from(
    new Set((preview?.images ?? []).filter((url): url is string => !!url)),
  );

  if (fromResearch.length > 0) return fromResearch;
  if (preview?.screenshot_url) return [preview.screenshot_url];

  return [];
}

/** Mosaic / backdrop pool: research URLs only, else bundled placeholders (never both). */
export function trialImages(fromPreview: Array<string | null | undefined>): string[] {
  const fromResearch = Array.from(new Set(fromPreview.filter((url): url is string => !!url)));

  if (fromResearch.length > 0) return fromResearch;

  return [...TRIAL_FALLBACK_IMAGES];
}

export function trialMosaicPhotoUrl(pool: string[], photoIndex: number): string {
  if (pool.length === 0) {
    return TRIAL_FALLBACK_IMAGES[photoIndex % TRIAL_FALLBACK_IMAGES.length];
  }

  return pool[photoIndex % pool.length];
}

export function trialMosaicImageFallback(pool: string[], failedUrl: string, attempt: number): string | null {
  if (pool.length === 0) return null;

  const start = pool.indexOf(failedUrl);
  const from = start >= 0 ? start : 0;

  for (let step = 1; step <= pool.length; step += 1) {
    const candidate = pool[(from + step) % pool.length];

    if (candidate !== failedUrl) return candidate;
  }

  return attempt < pool.length ? pool[(from + attempt + 1) % pool.length] : null;
}
